<template>
    <ModalBase :with-content="true" @close="closeModal">
        <form v-if="newShade">
            <div class="modalContent">
                <Loader :loading="loading"></Loader>
                <h1 class="uppercase productShadeTitle" v-if="newShade.hasOwnProperty('name') && newShade.name !== null">{{ newShade.name }}</h1>
                <h1 class="uppercase productShadeTitle" v-else="">NO NAME</h1>
                <span width="30%" class="labelInput uppercase ff-medium">{{ $t("crudComponent.name") }} <sup>*</sup></span>
                <input
                    class="inputShades"
                    type="text"
                    v-model="newShade.name"
                    required="true"
                    style="width: 20%; margin-left: 180px;margin-bottom: 12px;"
                />
                <div v-if="isDuplicate.name.existed" v-html-safe="isDuplicate.name.message" v-bind:class="'duplicate-teinte'"></div>
                <div v-for="(n, key) in getShadesProperties" :key="key" class="flexContainer" id="shadesTable" style="width: 100%;" v-if="key !== 6">
                    <span class="labelInput uppercase ff-medium" style="width: 30%"
                        >{{ n.terms.name[$t("trad")] }} <span v-if="!!(key == 2)">*</span></span
                    >
                    <input
                        class="inputShades"
                        style="width: 20%"
                        @focus.prevent.stop="overColorInfo(n.id);"
                        type="text"
                        :required="!!(key == 2)"
                        :value="getShadeProperty(n.id, newShade.properties)"
                        @change="setPropertyValue(n.id, newShade.properties, $event.target.value);"
                        @blur="outColorInfo(n.id);"
                    />
                    <div v-if="isDuplicate.ref.existed && !!(key == 2)" v-html-safe="isDuplicate.ref.message" v-bind:class="'duplicate-teinte'"></div>
                    <div v-if="showInfo === true && n.id === 5" class="abs help">Exemple: rgb(xxx,xxx,xxx) / #727A96</div>
                    <div v-if="n.id === 5" class="rel">
                        <div class="colors abs" :style="'background:' + getPropertyColor(n.id, newShade.properties) + ';'"></div>
                        <label for="" class="teinteCert rel"
                            >{{ $t("shades.certified") }} <input type="checkbox" id="zoneChecked" class="zoneChecked" v-model="selectedCert"
                        /></label>
                    </div>
                </div>
            </div>
            <br />
            <div>
                <span class="labelInput uppercase ff-medium">{{ $t("crudComponent.launchDate") }}</span>
                <select class="uppercase" name="" v-model="newShade.campaign.id">
                    <option v-for="m in launchCampaign" :key="m.id" v-bind:value="m.id" :selected="m.id == product.campaigns.launch.id">
                        {{ m.name }}
                    </option>
                </select>
                <span class="labelInput uppercase ff-medium">{{ $t("crudComponent.discontinued") }}</span>
                <select class="uppercase" name="" v-model="newShade.campaignDiscontinued.id">
                    <option class="uppercase" value="null" selected>Not discontinued</option>
                    <option v-for="m in discontinuedCampaign" :key="m.id" :value="m.id">{{ m.name }}</option>
                </select>
            </div>
            <br />
            <div>
                <h2 class="labelInput uppercase ff-medium">SELECTIONNER LA ZONE</h2>
                <div class="zones">
                    <table id="zoneTable" cellpadding="5" v-if="currentBrand">
                        <tr v-for="(m, key) in this.newShade.zonesByRole" :key="key">
                            <td>
                                <span class="labelInput uppercase ff-medium">{{ m.zone.name }}</span>
                            </td>
                            <td>
                                <input
                                    type="checkbox"
                                    :value="m.zone.id"
                                    v-model="selectedZones"
                                    @change="zoneChecked(m.zone, $event);"
                                    class="zoneChecked"
                                />
                            </td>

                            <td>
                                <select class="uppercase" v-model="testZoneModel[key].campaignLaunch.id">
                                    <option v-for="(m, key) in launchCampaignPerZone" :key="key" :value="m.id">{{ m.name }} </option>
                                </select>
                            </td>
                            <td>
                                <select class="uppercase" name="" v-model="testZoneModel[key].campaignDiscontinued.id">
                                    <option class="uppercase" value="null" selected>Not discontinued</option>
                                    <option v-for="m in discontinuedCampaignPerZone" :key="m.id" :value="m.id">{{ m.name }} </option>
                                </select>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <br />
            <div class="flexContainer boutonSaveDelete">
                <button class="btn block pointer uppercase save" type="submit" @click.prevent="saveEditShade">{{ $t("favorite.save") }}</button>
                <button class="btn block pointer" type="submit" @click.prevent="deleteShade" v-if="hasAccessDelete('shade_manager')">
                    {{ $t("actions.remove") }}
                </button>
            </div>
        </form>
    </ModalBase>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import httpService from "../service";
import ModalBase from "@/components/modal/ModalBase";
import Loader from "@/components/loader/loader";

export default {
    data() {
        return {
            loading: null,
            showInfo: false,
            product: {},
            zonesTmp: [],
            newShade: null,
            color: [],
            objectPropertyType: {},
            properties: [],
            selectedZones: [],
            testZoneModel: [],
            selectedCert: null,
            campaignList: {},
            isDuplicate: {
                name: {
                    existed: false,
                    message: ""
                },
                ref: {
                    existed: false,
                    message: ""
                }
            },
            launchCampaignPerZone: null,
            discontinuedCampaignPerZone: null,
            launchCampaign: null,
            discontinuedCampaign: null,
            tmpTab: null,
            campaignResponse: null
        };
    },
    components: {
        ModalBase,
        Loader
    },
    watch: {
        newShade() {
            let id = {
                id: null
            };
            for (let i in this.getShadesProperties) {
                let objectPropertyType = {
                    propertyType: {
                        id: this.getShadesProperties[i].id
                    },
                    value: null
                };
                this.properties.push(objectPropertyType);
            }
            if (this.newShade.campaignDiscontinued === null) {
                this.newShade.campaignDiscontinued = id;
            }
        },
        "product.campaigns.launch.id"() {
            let tab = [];
            let launchDate = null;
            for (let launchId in this.launchCampaign) {
                if (this.launchCampaign[launchId].id === this.product.campaigns.launch.id) {
                    launchDate = this.launchCampaign[launchId].launchDate;
                }
            }
            for (let item in this.discontinuedCampaign) {
                if (this.discontinuedCampaign[item].launchDate > launchDate) {
                    tab.push(this.discontinuedCampaign[item]);
                }
            }
            this.discontinuedCampaign = tab;

            for (let item in this.testZoneModel) {
                this.testZoneModel[item].campaignLaunch.id = this.product.campaigns.launch.id;
                this.testZoneModel[item].campaignDiscontinued.id = this.product.campaigns.discontinued.id;
            }
        },
        product() {
            httpService.get("/admin/campaigns/list?limit=100").then(response => {
                this.campaignResponse = response.data;
                this.launchCampaign = this.campaignResponse;
                this.launchCampaignPerZone = this.campaignResponse;
                this.discontinuedCampaignPerZone = this.campaignResponse;
                this.discontinuedCampaign = this.campaignResponse;
                this.tmpTab = this.campaignResponse;
                this.campaignList = this.campaignResponse;
            });
        }
    },
    mounted() {},
    methods: {
        overColorInfo(id) {
            if (id === 5) {
                this.showInfo = true;
            }
        },
        outColorInfo(id) {
            if (id === 5) {
                this.showInfo = false;
            }
        },
        closeModal() {
            this.$emit("hideEditShade");
        },
        zoneChecked(a, event) {
            let checked = event.target.checked;
            let zones = this.newShade.zones;
            let zone;
            for (let i in zones) {
                zone = zones[i];
                if (zone.zone.id === a.id) {
                    if (checked === false) {
                        this.zonesTmp.splice(this.zonesTmp.indexOf(zone), 1);
                    } else {
                        this.zonesTmp.push(zone);
                    }
                }
            }
            if (checked) {
                let zone1 = this.zonesTmp.find(z => {
                    return z.zone.id === a.id;
                });
                if (!zone1) {
                    let zonesObject = {
                        zone: {
                            id: a.id
                        },
                        campaignLaunch: {
                            id: this.getDetails(this.$route.params.id).campaigns.launch.id
                        },
                        launchDate: null,
                        campaignDiscontinued: {
                            id: null
                        },
                        discontinuedDate: null
                    };
                    this.zonesTmp.push(zonesObject);
                    this.newShade.zones.push(zonesObject);
                }
            }
        },
        saveEditShade(a) {
            delete this.newShade.zonesByRole;
            if (this.newShade.campaignDiscontinued.id === "") {
                this.newShade.campaignDiscontinued = null;
            }
            this.newShade.zones = this.zonesTmp;
            this.newShade.isCertified = document.getElementById("zoneChecked").checked;
            for (let j in this.newShade.zones) {
                let i = 0;
                while (i < this.testZoneModel.length) {
                    if (this.newShade.zones[j].zone.id === this.testZoneModel[i].zone.id) {
                        if (this.testZoneModel[i].campaignDiscontinued.id === null) {
                            this.newShade.zones[j].campaignDiscontinued = null;
                        } else {
                            if (this.newShade.zones[j].campaignDiscontinued) {
                                this.newShade.zones[j].campaignDiscontinued.id = this.testZoneModel[i].campaignDiscontinued.id;
                            } else {
                                let id = {
                                    id: this.testZoneModel[i].campaignDiscontinued.id
                                };
                                this.newShade.zones[j].campaignDiscontinued = id;
                            }
                        }
                        if (this.testZoneModel[i].campaignLaunch.id === null) {
                            this.newShade.zones[j].campaignLaunch = null;
                        } else {
                            if (this.newShade.zones[j].campaignLaunch) {
                                this.newShade.zones[j].campaignLaunch.id = this.testZoneModel[i].campaignLaunch.id;
                            } else {
                                let id = {
                                    id: this.testZoneModel[i].campaignLaunch.id
                                };
                                this.newShade.zones[j].campaignLaunch = id;
                            }
                        }
                        i = i + 1;
                    } else {
                        i = i + 1;
                    }
                }
            }
            httpService
                .put("/admin/components/" + this.$route.params.id + "/shade/" + this.getEditShadeID, JSON.stringify(this.newShade))
                .then(response => {
                    if (response.name || response.client_ref1) {
                        this.isDuplicate = {
                            name: {
                                existed: !!response.name,
                                message: "Ce nom existe déjà sur le produit"
                            },
                            ref: {
                                existed: !!response.client_ref1,
                                message: "Cette reference client existe déjà"
                            }
                        };
                    } else {
                        location.reload();
                    }
                });
        },
        deleteShade() {
            let self = this;
            self.loading = !self.loading;
            httpService.get("/shades/" + this.getEditShadeID + "/used").then(function(response) {
                self.loading = false;
                if (response.length === 0) {
                    self.$swal({
                        text: self.$t("shades.afterDelete"),
                        type: "success",
                        showCancelButton: true,
                        confirmButtonColor: "red",
                        confirmButtonText: self.$t("shades.confirmDelete"),
                        cancelButtonText: self.$t("actions.cancel"),
                        closeOnConfirm: true
                    }).then(result => {
                        self.loading = !self.loading;
                        httpService.delete("/shades/" + self.getEditShadeID).then(function(response) {
                            self.loading = false;
                            location.reload();
                        });
                    });
                } else {
                    let planoName = '<ul style="list-style: none">';
                    for (let i in response) {
                        if (response[i]) {
                            planoName +=
                                '<li><strong><a style="text-decoration: none; color: #343434" target="_blank" href="../plano/' +
                                response[i].id +
                                '" >' +
                                response[i].name +
                                "</a></strong></li>";
                        }
                    }
                    planoName += "</ul>";
                    self.$swal({
                        html: self.$t("shades.deleteWarnig") + planoName,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "red",
                        confirmButtonText: self.$t("shades.confirmDelete"),
                        cancelButtonText: self.$t("actions.cancel"),
                        closeOnConfirm: true
                    }).then(result => {});
                }
            });
        },
        getPropertyColor(id, properties) {
            let property = properties.find(prop => {
                return prop.propertyType.id === id;
            });

            if (property === undefined) return "#FFF";
            return property.value;
        },
        setPropertyValue(id, properties, value) {
            let property = properties.find(prop => {
                return prop.propertyType.id === id;
            });
            if (property === undefined) {
                property = {
                    propertyType: {
                        id: id
                    },
                    value: value
                };
                this.newShade.properties.push(property);
            } else {
                property.value = value;
            }
        },
        getShadeProperty(id, properties) {
            let property = properties.find(prop => {
                return prop.propertyType.id === id;
            });
            let value = "";
            if (property !== undefined) {
                if (property.value !== undefined) {
                    value = property.value;
                }
            }
            return value;
        }
    },
    computed: {
        ...mapGetters({
            getDetails: "items/getDetails",
            getEditShadeID: "shade/getEditShadeID",
            getShadesProperties: "shade/getShadesProperties"
        }),
        ...mapState("currentUser", ["currentBrand"])
    },
    created() {
        this.$store.dispatch("items/getDetails", { id: this.$route.params.id }).then(response => {
            if (response.code === 404) {
                this.product = "empty";
            } else {
                this.product = this.getDetails(this.$route.params.id);
            }
        });
        this.$store.dispatch("shade/getShadesProperties").then(response => {});
        httpService.get("/admin/components/" + this.$route.params.id + "/shades/" + this.getEditShadeID).then(response => {
            this.newShade = response;
            this.newShade.zones = [];
            for (let i in this.newShade.zonesByRole) {
                if (this.newShade.zonesByRole[i].shadeHasZone) {
                    this.newShade.zones.push(this.newShade.zonesByRole[i]);
                }
            }
            for (let i in this.newShade.zonesByRole) {
                let zonesObject = {
                    zone: {
                        id: this.newShade.zonesByRole[i].zone.id
                    },
                    campaignLaunch: {
                        id: this.getDetails(this.$route.params.id).campaigns.launch.id
                    },
                    launchDate: null,
                    campaignDiscontinued: {
                        id: null
                    },
                    discontinuedDate: null
                };

                this.testZoneModel.push(zonesObject);
            }

            this.newShade.zones.forEach(zone => {
                this.selectedZones.push(zone.zone.id);
                this.zonesTmp.push(zone);
                this.testZoneModel.forEach(model => {
                    if (model.zone.id === zone.zone.id) {
                        if (zone.campaignLaunch !== null) {
                            model.campaignLaunch.id = zone.campaignLaunch.id;
                        }
                        if (zone.campaignDiscontinued !== null) {
                            model.campaignDiscontinued.id = zone.campaignDiscontinued.id;
                        }
                    }
                });
            });
            this.selectedCert = response.isCertified;
        });
    }
};
</script>

<style lang="scss" scoped>
.zones {
    height: 150px;
    overflow-y: scroll;
}

.boutonSaveDelete {
    margin-left: 290px;
    .save {
        margin-right: 12px;
    }
}

.help {
    margin-top: 20px;
    margin-left: 262px;
}

.teinteCert {
    padding-left: 60px;
    font-size: 12px;
    text-transform: initial;
}

.zoneChecked {
    margin-left: 2px;
}

#shadesTable {
    width: 40%;
    padding-bottom: 12px;
}

.productShadeTitle {
    font-family: "Oswald", Sans-Serif;
}

.inputShades {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
}

.colors {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-top: -16px;
    margin-left: 190px;
}

.labelInput {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 12px;
    padding-left: 20px;
    padding-right: 10px;
}

.duplicate-teinte {
    color: red;
    font-size: 12px;
    text-align: center;
    margin-left: 10px;
    display: inline-block;
    position: relative;
    top: 7px;
}
</style>



// WEBPACK FOOTER //
// EditShade.vue?0b1cec9b